function renderSelectFieldChangeHandlerTemplate({
  indent,
  defaultValueFromHandler
}: {
  indent: string
  defaultValueFromHandler: string
}): string {
  return `(value) => {
${indent}            ${defaultValueFromHandler}(value)
${indent}            formField.onChange(value)
${indent}          }`
}

function renderSelectFieldFormFieldTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  validValuesExpression,
  onValueChange,
  selectedLabelExpression,
  stringify,
  optionsJsx
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  validValuesExpression: string
  onValueChange: string
  selectedLabelExpression: string
  stringify: string
  optionsJsx: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <Select
${indent}          value={typeof formField.value === "string" && ${validValuesExpression}.includes(formField.value) ? formField.value : undefined}
${indent}          onValueChange={${onValueChange}}
${indent}          disabled={isPending}
${indent}        >
${indent}          <SelectTrigger className="w-full">
${indent}            <span data-slot="select-value" className="pointer-events-none">
${indent}              {(${selectedLabelExpression}) ?? ${stringify}}
${indent}            </span>
${indent}          </SelectTrigger>
${indent}          <SelectContent alignItemWithTrigger={false} align="start">
${optionsJsx}
${indent}          </SelectContent>
${indent}        </Select>
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}

export function renderSelectFieldRenderer(
  request:
    | {
        kind: 'renderSelectFieldChangeHandlerTemplate'
        props: {
          indent: string
          defaultValueFromHandler: string
        }
      }
    | {
        kind: 'renderSelectFieldFormFieldTemplate'
        props: {
          indent: string
          fieldName: string
          formItemProps: string
          labelWithDescription: string
          validValuesExpression: string
          onValueChange: string
          selectedLabelExpression: string
          stringify: string
          optionsJsx: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderSelectFieldChangeHandlerTemplate':
      return renderSelectFieldChangeHandlerTemplate(request.props)
    case 'renderSelectFieldFormFieldTemplate':
      return renderSelectFieldFormFieldTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
